import React from 'react';
import block from 'bem-cn-lite';
import {Button} from '@yandex-data-ui/common';
import {HTML} from '@doc-tools/components';

import withTranslation, {WithTranslationProps} from 'hoc/withTranslation';

import './CalculatorFormError.scss';

const b = block('CalculatorFormError');

export interface CalculatorFormErrorProps extends WithTranslationProps {
    title: string;
    description?: string;
    action: {
        text?: string;
        handler: () => void | Promise<void>;
    };
}

const CalculatorFormError: React.FC<CalculatorFormErrorProps> = ({
    title,
    description,
    action,
    i18nK,
}) => (
    <div className={b()}>
        <div className={b('title')}>
            <HTML>{title}</HTML>
        </div>
        <div className={b('description')}>{description ?? i18nK('label_error')}</div>
        <div className={b('action')}>
            <Button view="outlined" size="l" onClick={action?.handler}>
                {action?.text ?? i18nK('button_try-again')}
            </Button>
        </div>
    </div>
);

export default withTranslation('calculator')(CalculatorFormError);
